import { render, staticRenderFns } from "./AddCentralUnit.vue?vue&type=template&id=1f9601f6&"
import script from "./AddCentralUnit.vue?vue&type=script&lang=js&"
export * from "./AddCentralUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports